import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import MenuIcon from "@mui/icons-material/Menu";
import { Typography } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Logo from "./components/Logo";
// import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
// import Input from "@/components/core/material-ui/components/MuiInput";
// import InputAdornment from "@mui/material/InputAdornment";
// import SearchIcon from "@mui/icons-material/Search";
import {
  HEADER_MENU,
  INTENTS,
  LOB,
  PAGE_ROUTES,
  RETENTION_HEADER_MENU,
  USER_TYPES,
} from "@/config/constants";
import { getMetadata } from "@/features/metadata/metadataSlice";
import { getInitial } from "@/helpers/utils";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useRouter } from "next/router";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import BoltLogo from "./components/BoltLogo";
import HeaderSkeleton from "@/components/skeleton/HeaderSkeleton";
import { REDIRECTION_URL, SPA_REDIRECTION_URL } from "@/config/config";
import { removeReduxData } from "@/features/error/errorSlice";
import { isSkeletonActive } from "@/features/loader/loaderSlice";
import {
  clearProposalData,
  getActiveState,
  getFromOrderTracking,
  getIntent,
  setFromOrderTracking,
  setIsEndorsementFieldEditable,
  setIsFromEndorsementsActionsPage,
  updateActiveState,
} from "@/features/proposal/proposalSlice";
import { clearQuoteData } from "@/features/quote/quoteSlice";
import theme from "@/helpers/theme";
import BackButton from "../../material-ui/components/back-button";
import { clearQuoteDataPA } from "@/features/quote-pa/quotePaSlice";

export const HeaderSection = () => {
  const router = useRouter();
  const metadata = useSelector(getMetadata);
  const { userType, lob = LOB.HEALTH } = metadata;
  const intent = useSelector(getIntent);
  const [anchorElUser, setAnchorElUser] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const headerMenu =
    // lob === LOB.HEALTH
    //   ?
    userType === USER_TYPES.RETENTION || userType === USER_TYPES.COPS
      ? RETENTION_HEADER_MENU
      : HEADER_MENU;
  // : [HEADER_MENU[0]];

  const redirectionURL =
    intent === INTENTS.ENDORSEMENT ? SPA_REDIRECTION_URL : REDIRECTION_URL;
  const handleClickMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const getBaseRoute = (route) => {
    const paths = route.split("/").filter(Boolean);
    return `/${paths[0]}`;
  };
  const baseRoute = getBaseRoute(router.pathname);
  // const [showSearch, setShowSearch] = useState(false);
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const dispatch = useDispatch();
  const handleUserMenuItemClick = () => {
    router.replace(redirectionURL);
    dispatch(removeReduxData());
  };
  const fromOrderTracking = useSelector(getFromOrderTracking);
  const isLoading = useSelector(isSkeletonActive);
  const activeStep = useSelector(getActiveState);
  const handleClick = (step) => {
    dispatch(updateActiveState(step));
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      {isLoading ? (
        <HeaderSkeleton />
      ) : (
        <Box sx={{ boxShadow: `${theme.palette.shadow.header}` }}>
          {/* Mobile View Header */}
          <Box
            sx={{
              position: "fixed",
              top: 0,
              bgcolor: "background.default",
              zIndex: 1000,
              display: { xs: "block", md: "none" },
              width: { xs: "100%" },
              px: "1rem",
              margin: "0 auto",
              boxShadow: `${theme.palette.shadow.header}`,
            }}
          >
            <Box
              display="flex"
              justifyContent="space-between"
              // alignItems="center"
              py="0.1rem"
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <BackButton
                  sx={{
                    fontSize: "1.25rem",
                    display: "flex",
                    position: "initial",
                    mr: "0.5rem",
                    mb: 1,
                  }}
                  backFunction={() => {
                    if (fromOrderTracking) {
                      router.back();
                      Object.values(INTENTS).includes(intent) &&
                        dispatch(setFromOrderTracking(false));
                      return;
                    } else {
                      activeStep > 0
                        ? handleClick(activeStep - 1)
                        : router.back();
                    }
                  }}
                />
                {userType !== USER_TYPES.CUSTOMER && (
                  <Logo width={96} height={40} handleLogoClick={() => {}} />
                )}
              </Box>

              {/* <BoltLogo sx={{ my: "1.5rem" }} /> */}

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  // margin: "0 1rem",
                }}
              >
                {/* <NotificationsNoneIcon
                  size="medium"
                  sx={{
                    marginRight: "0.75rem",
                  }}
                /> */}
                {(userType === USER_TYPES.AGENT ||
                  userType === USER_TYPES.RETENTION ||
                  (userType === USER_TYPES.COPS &&
                    router?.pathname !== PAGE_ROUTES.NSTP)) && (
                  <>
                    <IconButton onClick={handleClickMenu}>
                      <MenuIcon />
                    </IconButton>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                    >
                      {headerMenu.map(
                        ({ id, name, redirection, redirectionPA }) => {
                          return (
                            <MenuItem
                              key={id}
                              onClick={() => {
                                if (lob === LOB.PA) {
                                  router.replace(`/${redirectionPA}`);
                                } else {
                                  router.replace(`/${redirection}`);
                                }
                                setAnchorEl(null);
                                if (name === "Home") {
                                  dispatch(clearQuoteData());
                                  dispatch(clearQuoteDataPA());
                                  dispatch(clearProposalData());
                                } else if (name === "Order Tracking") {
                                  dispatch(
                                    setIsFromEndorsementsActionsPage(false),
                                  );
                                  dispatch(
                                    setIsEndorsementFieldEditable(false),
                                  );
                                }
                              }}
                            >
                              {name}
                            </MenuItem>
                          );
                        },
                      )}
                    </Menu>
                  </>
                )}
              </Box>
            </Box>
          </Box>
          {/* Desktop View Header */}
          <Box
            sx={{
              display: { xs: "none", md: "block" },
              bgcolor: "background.default",
              position: "sticky",
              top: 0,
              zIndex: 1000,
              width: "80%",
              mx: "auto",
            }}
          >
            <Box
              sx={{
                width: { xs: "100%", md: "96%" },
                margin: "auto",
                color: "color.aigColor11",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                py:
                  userType === USER_TYPES.AGENT ||
                  userType === USER_TYPES.RETENTION ||
                  userType !== USER_TYPES.CUSTOMER
                    ? "0.5rem"
                    : "0rem",
              }}
            >
              <Box>
                {userType !== USER_TYPES.CUSTOMER && (
                  <Logo handleLogoClick={() => {}} width={96} height={40} />
                )}
                {/* <BoltLogo /> */}
              </Box>
              <Box>
                {(userType === USER_TYPES.AGENT ||
                  userType === USER_TYPES.RETENTION ||
                  (userType === USER_TYPES.COPS &&
                    router?.pathname !== PAGE_ROUTES.NSTP)) && (
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    {headerMenu.map(
                      ({
                        id,
                        name,
                        redirection,
                        isExpandable,
                        redirectionPA,
                      }) => {
                        return (
                          <Typography
                            key={id}
                            variant="headerLinkStyle"
                            component="span"
                            onClick={() => {
                              if (lob === LOB.PA) {
                                router.replace(`/${redirectionPA}`);
                              } else {
                                router.replace(`/${redirection}`);
                              }
                              if (name === "Home") {
                                dispatch(clearQuoteData());
                                dispatch(clearQuoteDataPA());
                                dispatch(clearProposalData());
                              }
                            }}
                            sx={{
                              ml: "1.5rem",
                              color:
                                baseRoute === `/${redirection}`
                                  ? "color.aigColor1"
                                  : "",
                            }}
                          >
                            <Typography sx={{ display: "flex" }}>
                              {name} {isExpandable ? <ArrowDropDownIcon /> : ""}
                            </Typography>
                          </Typography>
                        );
                      },
                    )}
                  </Box>
                )}
              </Box>

              <Box>
                {/* TODO: we will uncomment this */}
                {/* {!showSearch ? (
              <SearchIcon
                onClick={() => {
                  setShowSearch(true);
                }}
              />
            ) : (
              <Box>
                <Input
                  size="small"
                  helperText=""
                  InputProps={{
                    style: {
                      borderRadius: "2.5rem",
                    },
                    startAdornment: (
                      <InputAdornment>
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>
            )} */}
                {(userType === USER_TYPES.AGENT ||
                  userType === USER_TYPES.RETENTION) && (
                  <>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <IconButton
                        onClick={handleOpenUserMenu}
                        sx={{
                          marginLeft: "1.6rem",
                        }}
                      >
                        <Avatar sx={{ bgcolor: "background.secondary" }}>
                          {getInitial(metadata?.agentName || "R J")}
                        </Avatar>
                        {/* <ArrowDropDownIcon /> */}
                      </IconButton>
                      {/* <NotificationsNoneIcon
                        size="medium"
                        sx={{
                          marginLeft: "2rem",
                        }}
                      /> */}
                    </Box>
                    <Menu
                      sx={{ mt: "3rem" }}
                      id="menu-appbar"
                      anchorEl={anchorElUser}
                      anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      keepMounted
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      open={Boolean(anchorElUser)}
                      onClose={handleCloseUserMenu}
                    >
                      <MenuItem>
                        <Typography
                          textAlign="center"
                          onClick={() => handleUserMenuItemClick()}
                        >
                          Logout
                        </Typography>
                      </MenuItem>
                    </Menu>
                  </>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};
